import state from './managersState'
import mutations from './managersMutations'
import getters from './managersGetters'
// import actions from './managersActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  // actions,
}
